// extracted by mini-css-extract-plugin
module.exports = {"container":"-D8lgGvs52nRwFHoQeP_q","videoContainer":"_37nEuWLl8uSrxeFbzTOMeA","content":"_2ntAgFFM8DaCku2woDv9j9","text":"_21Phk069nVJ9SM2A9f8zgf"};